import { add, isPast, set } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

import { formatDateWithTimeToBE } from '../../../../../../../helpers/date'

import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import store from '../../../../../../../store'
import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const getGamAdAccountTimezone = () => {
  const selectedPartnership = selectedPartnershipSelector(store.getState())
  const gamAdAccount = selectedPartnership?.[GOOGLE_AD_MANAGER_AD_ACCOUNT]
  return gamAdAccount?.timezone_name
}

export const formatStartDateForGAM = startDate => {
  // Handle edge cases: empty strings
  if (!startDate || startDate === '') {
    return null
  }

  const dateObject = new Date(startDate)

  const initialStartDate = set(dateObject, {
    hours: 0,
    minutes: 0
  })

  const gamTimezone = getGamAdAccountTimezone()

  // Convert to GAM account timezone
  const gamTimezoneDate = toZonedTime(initialStartDate, gamTimezone)

  // if start date is in past > set final start date as (current time + one minute) in GAM timezone
  if (isPast(gamTimezoneDate)) {
    const nowInGamTimezone = toZonedTime(new Date(), gamTimezone)
    const futureDate = add(nowInGamTimezone, { minutes: 1 })
    return formatDateWithTimeToBE(futureDate)
  }

  return formatDateWithTimeToBE(gamTimezoneDate)
}
